<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<section class="po_search_bar">
  <div class="row no-mar-lr">
    <div class="offset-md-2 col-md-3 mar-tb-25 text-right">
      <!-- <select class="form-control">
        <option>Supplier Code</option>
        <option>Supplier Manager</option>
      </select> -->
      <ng-multiselect-dropdown *ngIf="suppCodeList"  [(ngModel)]="suppSelect" [settings]="dropdownSettings" [data]="suppCodeList">
      </ng-multiselect-dropdown>
    </div>

    <div class="col-md-3 mar-tb-25">

      <!-- <dp-date-picker [(ngModel)]="selectedDate" [config]="datePickerConfig"></dp-date-picker> -->

      <dp-date-picker mode="month" class="form-control" [(ngModel)]="selectedDate" [config]="datePickerConfig"></dp-date-picker>

    </div>

    <div class="col-md-3 mar-tb-25">
      <button class="btn btn-dark" type="button" (click)="showPoLedger()">Search</button>
    </div>
  </div>
</section>

<section>
  <div class="dta_title mar-tb-20 pad-lr-15 col-md-6">All Vendors With Packages</div>

  <div class="row no-mar-lr">
    <div class="col-md-9 mar-lft-20">
      <table class="table table-light table-bordered">
        <thead>
          <tr>
            <th scope="col">Supplier</th>
            <th scope="col">Supplier Name</th>
            <th scope="col">Location</th>
            <th scope="col">Sum Order of No Packaging</th>
            <th scope="col">Sum of Total Order Quantity</th>
            <th scope="col">Missing %</th>
            <th scope="col">Total Box Count</th>
            <th scope="col">Total Order m3</th>
            <th scope="col">Total KG</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="hasLink" routerLink="/poTotal">B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</section>